import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const shopifyRoutes: PermissionedRouteObject[] = [
  {
    path: "install",
    async lazy() {
      const { ShopifyCallback } = await import("./callback");
      return { Component: ShopifyCallback };
    },
  },
];
